export enum NotificationType {
  PlanCloneCompleted = 'STRATEGY_PLAN_CLONE_COMPLETED'
}
